import { useQuery } from '@apollo/client'
import { FETCH_CANCELLATION_METRICS_CHART_DATA } from '@/gf/queries/metrics'
import { CancellationMetricsChartDatum, MetricsLineChartVars } from '../../types'

interface FetchCancellationMetricsChartResults {
  chartData: CancellationMetricsChartDatum[]
}
interface FetchCancellationMetricsChartData {
  fetchCancellationMetricsChartData: FetchCancellationMetricsChartResults
}
type FetchCancellationMetricsChartDataVars = MetricsLineChartVars

const useCancellationMetricsChartData = ({
  fromDate,
  toDate,
  selectedStoreId,
  periodDays,
}: FetchCancellationMetricsChartDataVars) => {
  const { loading, error, data } = useQuery<
    FetchCancellationMetricsChartData,
    FetchCancellationMetricsChartDataVars
  >(FETCH_CANCELLATION_METRICS_CHART_DATA, {
    variables: { fromDate, toDate, selectedStoreId, periodDays },
    fetchPolicy: 'no-cache',
  })

  return { loading, error, data: data?.fetchCancellationMetricsChartData.chartData }
}

export default useCancellationMetricsChartData
